// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-field-group-confirm-type-change {
  width: 380px;
}

fi-data-field-group-edit-item-dialog-confirm-type-convert .convert-type-dialog-input {
  margin-top: 20px;
}
fi-data-field-group-edit-item-dialog-confirm-type-convert .convert-type-dialog-input .mat-mdc-form-field {
  display: block;
}`, "",{"version":3,"sources":["webpack://./Source/app/data-field/data-field-group-edit/dialog-confirm-type-convert/dialog-confirm-type-convert.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;;AAGI;EACI,gBAAA;AAAR;AAEQ;EACI,cAAA;AAAZ","sourcesContent":[".data-field-group-confirm-type-change {\r\n    width: 380px;\r\n}\r\n\r\nfi-data-field-group-edit-item-dialog-confirm-type-convert {\r\n    .convert-type-dialog-input {\r\n        margin-top: 20px;\r\n\r\n        .mat-mdc-form-field {\r\n            display: block;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
